exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".createideabutton-cssmodule-btn-create-idea-o2cbf>.createideabutton-cssmodule-title-33Wrm{margin-top:22px;font-weight:700}.createideabutton-cssmodule-btn-icon-1KQN4{width:64px}.createideabutton-cssmodule-btn-create-idea-o2cbf{width:100%}", ""]);

// exports
exports.locals = {
	"btn-create-idea": "createideabutton-cssmodule-btn-create-idea-o2cbf",
	"title": "createideabutton-cssmodule-title-33Wrm",
	"btn-icon": "createideabutton-cssmodule-btn-icon-1KQN4"
};


//////////////////
// WEBPACK FOOTER
// ../~/css-loader?{"modules":true,"importLoaders":1,"localIdentName":"[name]-[local]-[hash:base64:5]"}!../~/postcss-loader!../~/sass-loader!./components/Shared/createideabutton.cssmodule.scss
// module id = 610
// module chunks = 0